<template>
    <div>
        <div id="home" class="logistic-background position-relative">
            <div class="position-absolute w-100 overflow-hidden" style="height: 95%">
                <video class="h-100 w-100" style="object-fit: cover; object-position: center;" autoplay muted loop>
                    <source src="../assets/videos/logistics.mp4" type="video/mp4">
                </video>
            </div>
            <!-- Home Page -->
            <div id="first-container" class="container mx-auto row" style="padding-top: 8rem;">
                <div id="TatSingLogistics" class="mt-5 col-sm-12 col-md-6 h-100">
                    <div class="position-relative h-100" data-aos="zoom-out-right" data-aos-duration="1000">
                        <p class="fs-1 lh-sm my-5 text-white">Your <strong class="text-theme">navigator</strong> in the
                            <br> world of trade</p>

                        <a href="/#about" class="text-decoration-none"><button type="button"
                            class="bg-dark p-2 rounded d-flex align-items-center gap-3 text-white">Learn More <img
                                src="../assets/img/arrow-down.png" alt="arrow-down" height="16"></button></a>
                    </div>
                </div>
                <div id="track" class="container col-sm-12 col-md-6 mt-3">
                    <div class="card bg-light rounded shadow-sm m-auto py-4 h-100" style="width: 80%;"
                        data-aos="fade-up" data-aos-duration="1500" data-aos-easing="ease-in-out" data-aos-mirror="true"
                        data-aos-once="true">
                        <div id="track-search" class="text-center px-5 h-100">
                            <div class="px-3 py-1 d-flex flex-column gap-2 gap-md-4">
                                <h1 class="fw-bold w-100 mb-0 track-message" style="font-size: 2rem;">Our Global Networks & Accreditations</h1>
                                <!-- <img src="../assets/img/Messenger-cuate.png" alt="question-mark"
                                    class="w-100 my-3 track-img" style="height: 250px;"> -->
                                <div class="d-flex flex-wrap justify-content-evenly gap-0 gap-md-2" style="min-height: 200px;">
                                    <img
                                    id="wca"
                                    src="../assets/img/WCAChinaGlobal.png"
                                    alt="WCA China"
                                    style="max-width:150px; max-height: 70px;"
                                    >
                                    <img
                                    id="philexport"
                                    src="../assets/img/philexport.png"
                                    alt="PhilExport"
                                    style="max-width:150px; max-height: 70px;"
                                    >
                                    <img
                                    id="jctrans"
                                    src="../assets/img/jctrans.png"
                                    alt="JC Trans"
                                    style="max-width:200px; max-height: 70px;"
                                    >
                                    <img
                                    id="boc"
                                    src="../assets/img/BOC-logo.png"
                                    alt="BOC"
                                    style="max-width:100px; max-height: 100px;"
                                    >
                                </div>
                                <h1 class="fw-bold w-100 mb-0 track-message" style="font-size: 1.7rem;">Partner with Us for Reliable Logistics</h1>
                                <span class="fs-6 fs-md-2">Discover seamless shipping solutions for your business, from warehousing to international forwarding.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="about" class="vh-100 container p-5" data-aos="fade-right" data-aos-duration="1000"
            data-aos-offset="100" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
            <div class="position-relative w-100 d-flex flex-column mt-5">
                <span class="fs-3 fw-bold text-uppercase px-1 text-theme">About Us</span>
                <span
                    class="position-absolute h-100 border-bottom border-5 left-0 my-1 border-secondary-theme underline"></span>
            </div>
            <div class="row">
                <div class="my-4 col-sm-12 col-md-6">
                    <div class="w-75">
                        <span class="display-5 fw-bold">We are proud to transact since <span
                                class="text-theme">2017</span></span>
                        <img src="../assets/img/about-us.png" alt="about-us"
                            class="h-auto w-100 my-4 shadow-lg rounded-circle">
                    </div>
                </div>
                <div class="my-5 col-sm-12 col-md-6" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="100"
                    data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                    <h1 class="display-5 fw-bold mt-4">What do you need?</h1>

                    <div id="required" class="d-flex flex-wrap overflow-hidden">
                        <div class="w-50 h-50 p-2" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="100"
                            data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                            <a href="/pricing-and-plans" class="d-block h-100 text-decoration-none text-dark p-2 border border-dark rounded-3 shadow-sm">
                                <img src="../assets/img/icons/Outline.png" alt="facility" height="100">
                                <h1 class="fw-bold fs-2 my-2">Get a Quote</h1>
                                <p>Explore flexible packages tailored to fit your needs, with transparent pricing and no
                                    hidden fees.</p>
                            </a>
                        </div>
                        <div class="w-50 h-50 p-2" data-aos="fade-left" data-aos-duration="2000" data-aos-offset="100"
                            data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                            <a href="/pricing-and-plans" class="d-block h-100 text-decoration-none text-dark p-2 border border-dark rounded-3 shadow-sm">
                                <img src="../assets/img/icons/Weights-table.png" alt="globe" height="100">
                                <h1 class="fw-bold fs-2 my-2">Weights Table</h1>
                                <p>View a detailed breakdown of weight categories and corresponding rates for quick and
                                    accurate reference.</p>
                            </a>
                        </div>
                        <div class="w-50 h-50 p-2" data-aos="fade-left" data-aos-duration="2500" data-aos-offset="100"
                            data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                            <a href="/pricing-and-plans" class="d-block h-100 text-decoration-none text-dark p-2 border border-dark rounded-3 shadow-sm">
                                <img src="../assets/img/icons/consulting.png" alt="staff" height="100">
                                <h1 class="fw-bold fs-2 my-2">Our Staff</h1>
                                <p>Meet our dedicated team of experts committed to delivering reliable service and customer
                                    care.</p>
                            </a>
                        </div>
                        <div class="w-50 h-50 p-2" data-aos="fade-left" data-aos-duration="3000" data-aos-offset="100"
                            data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                            <a href="/pricing-and-plans" class="d-block h-100 text-decoration-none text-dark p-2 border border-dark rounded-3 shadow-sm">
                                <img src="../assets/img/icons/Track.png" alt="facility" height="100">
                                <h1 class="fw-bold fs-2 my-2">Pricing and plans</h1>
                                <p>Choose the right plan for you affordable, scalable, and designed to match your goals.</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="services" class="bg-light min-vh-100">
            <div class="container mt-5 p-5 d-flex flex-column gap-0 gap-md-4">
                <div>
                    <div class="position-relative w-100 d-flex flex-column" data-aos="fade-down" data-aos-offset="100"
                        data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                        <span class="fs-3 fw-bold text-uppercase px-1 text-theme">Services</span>
                        <span
                            class="position-absolute h-100 border-bottom border-5 left-0 my-1 border-secondary-theme underline"></span>
                    </div>

                    <h1 class="display-4 fw-bold mt-4 w-50" data-aos="fade-down" data-aos-offset="100"
                        data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                        See what can we do for you and your business</h1>
                </div>

                <h1 class="fs-2 fw-bold text-secondary-theme mt-3" data-aos="fade-down" data-aos-offset="100"
                    data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                    Freight & Logistics Services
                </h1>

                <div class="row">
                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/custom-clearance-brokerage">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/customs-brokerage.jpg"
                                    alt="delivery-truck"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity: 0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Custom Clearance & Brokerage</h1>
                                    <p>
                                        Professional customs brokerage services to handle documentation,
                                        duties, and compliance so your cargo clears borders efficiently.
                                    </p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="100"
                        data-aos-duration="1500"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/warehousing-distribution">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/warehousing-distribution.jpg"
                                    alt="boxes"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity: 0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Warehousing and Distribution</h1>
                                    <p>
                                        Strategic warehousing and distribution services designed to manage inventory, improve delivery efficiency, and support supply chain operations.
                                    </p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>

                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="150"
                        data-aos-duration="2000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/freight-forwarding">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/international-domestic.jpg"
                                    alt="globe"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity: 0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">International & Domestic Freight Forwarding</h1>
                                    <p>
                                        Comprehensive freight forwarding solutions connecting local and international markets through reliable logistics coordination.
                                    </p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/air-sea-freight">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/air-sea-freight.jpg"
                                    alt="air-sea-freight"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Air & Sea Freight Services</h1>
                                    <p>Flexible air and ocean freight options that provide dependable transit times and competitive shipping solutions worldwide.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="100"
                        data-aos-duration="1500"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/fcl-lcl-shipments">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/fcl-lcl.jpg"
                                    alt="fcl-lcl"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">FCL & LCL Shipments</h1>
                                    <p>Efficient full container and consolidated cargo services to match your shipment volume and budget requirements.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="150"
                        data-aos-duration="2000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/nvocc">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/nvocc.jpg"
                                    alt="nvocc"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; object-position:left center; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">NVOCC</h1>
                                    <p>Non-Vessel Operating Common Carrier services providing flexible ocean freight capacity and reliable cargo space management.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/inland-inter-island-logistics">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/inland-interisland.jpg"
                                    alt="inland-inter-island"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Inland & Inter Island Logistics</h1>
                                    <p>Reliable inland and inter-island transportation solutions ensuring smooth cargo movement across regional and domestic routes.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="100"
                        data-aos-duration="1500"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/project-cargo">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/project-cargo.jpg"
                                    alt="project-cargo"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; object-position:left; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Project Cargo</h1>
                                    <p>Specialized logistics planning and handling for oversized, complex, and high-value project shipments.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="150"
                        data-aos-duration="2000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/ddu-ddp-services">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/ddu-ddp.jpg"
                                    alt="globe"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">DDU & DDP Services</h1>
                                    <p>End-to-end delivery solutions handling duties and logistics coordination for seamless international shipments.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                
                <h1 class="fs-2 fw-bold text-secondary-theme mt-3" data-aos="fade-down" data-aos-offset="100"
                    data-aos-duration="1000" data-aos-easing="ease-in-out" data-aos-mirror="true" data-aos-once="true">
                    Specialized Cargo Solutions
                </h1>

                <div class="row">
                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/dg-handling-solution">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/dg-handling.jpg"
                                    alt="dg-handling"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">DG Handling Solution</h1>
                                    <p>Safe and compliant handling of dangerous goods shipments following international safety standards and regulations.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="100"
                        data-aos-duration="1500"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/heavy-lift-operations">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/heavy-lift.jpg"
                                    alt="heavy-lift"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Heavy Lift Operations</h1>
                                    <p>Professional heavy lift handling and transport solutions for large-scale industrial equipment and oversized cargo.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>

                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-delay="150"
                        data-aos-duration="2000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/dry-bulk-break-bulk">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/bulk-cargo.jpg"
                                    alt="bulk-cargo"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Dry Bulk & Break Bulk Logistics</h1>
                                    <p>Efficient transport solutions for bulk commodities and non-containerized cargo across international trade routes.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 col-md-4 py-2 py-md-0"
                        data-aos="zoom-in"
                        data-aos-offset="100"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-out"
                        data-aos-mirror="true"
                        data-aos-once="true">
                        <a href="/customized-logistics">
                            <div class="pe-5 position-relative overflow-hidden h-100 rounded-3 services">
                                <img src="../assets/img/customized-logistics.jpg"
                                    alt="customized-logistics"
                                    class="position-absolute top-0 start-0 w-100 h-100"
                                    style="object-fit: cover; z-index:1;">
                                <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark"
                                    style="z-index:2; opacity:0.2;"></div>
                                <div class="position-absolute text-white p-3 bottom-0" style="z-index:3;">
                                    <h1 class="fs-4 my-3 w-75">Customized Logistics</h1>
                                    <p>Tailored logistics strategies designed to meet specific operational requirements and complex supply chain needs.</p>
                                    <span class="d-flex gap-2 align-items-center">Learn More <img src="../assets/img/arrow-right.png" style="width: 12px; height: 12px;" /></span>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Home',
}
</script>
